import { ViewModel,View, ObservableArray } from "binder"
import  { CreatePayableView } from "./createPayable-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PersonSearchViewModel } from "../personSearch-viewModel";
import { IGateway } from "./gateways/IGateway";
import { CashGatewayViewModel } from "./gateways/cashGateway/cashGateway-viewModel";
import { DebitGatewayViewModel } from "./gateways/debitGateway/debitGateway-viewModel";
import moment, { Moment } from "moment";
import { AttachmentListSelectorViewModel } from "../attachmentListSelector/attachmentListSelector-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { IPaymentInfoProvider } from "./gateways/IGateway";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { TranslatorConverter } from "src/TranslatorConverter";

export class CreatePayableViewModel extends WindowViewModel implements IPaymentInfoProvider{
    public getTitle(): string {
        return 'ثبت پرداخت';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.reasons = ObservableArray.create<reason>();
        this.reasons.update(...[new reason(this,1),new reason(this,2),new reason(this,3)]);
        this.personSelector = new PersonSearchViewModel(this);
        this.personSelector.onSelectionChanged = p=>{
            this.selectedPersonName = p.name;
            this.selectedPersonCode = p.code; 
        }
        this.gateways = ObservableArray.create<IGateway>();
        this.gateways.push(...[
            new CashGatewayViewModel(this),
            new DebitGatewayViewModel(this),
        ]);
        this.time = moment.utc(moment.now());
        this.attachments = new AttachmentListSelectorViewModel(this);
    }
    
    GetDefaultView(): View <ViewModel> {
        return new CreatePayableView();
    }
    public getTypeId(): string {
        return "VM-1D9C908E-0F0D-4B56-B923-3C35BD566572"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set personSelector(v: PersonSearchViewModel) { this._personSelector = v; } public get personSelector(): PersonSearchViewModel { return this._personSelector;} private _personSelector: PersonSearchViewModel;
    public set amount(v: number) { this._amount = getAsNumber(v,true); } public get amount(): number { return this._amount;} private _amount: number;
    public set time(v: moment.Moment) { this._time = v; } public get time(): moment.Moment { return this._time;} private _time: moment.Moment;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set requestType(v: string) { this._requestType = v; } public get requestType(): string { return this._requestType;} private _requestType: string;
    public set reasons(v: ObservableArray<reason>) { this._reasons = v; } public get reasons(): ObservableArray<reason> { return this._reasons;} private _reasons: ObservableArray<reason>;
    public set selectedReason(v: reason) { this._selectedReason = v; } public get selectedReason(): reason { return this._selectedReason;} private _selectedReason: reason;
    public set gateways(v: ObservableArray<IGateway>) { this._gateways = v; } public get gateways(): ObservableArray<IGateway> { return this._gateways;} private _gateways: ObservableArray<IGateway>;
    public set selectedPersonName(v: string) { this._selectedPersonName = v; } public get selectedPersonName(): string { return this._selectedPersonName;} private _selectedPersonName: string;
    public set selectedPersonCode(v: string) { this._selectedPersonCode = v; } public get selectedPersonCode(): string { return this._selectedPersonCode;} private _selectedPersonCode: string;
    public set attachments(v: AttachmentListSelectorViewModel) { this._attachments = v; } public get attachments(): AttachmentListSelectorViewModel { return this._attachments;} private _attachments: AttachmentListSelectorViewModel;
    
    public set selectedGateway(v: IGateway) { 
        v?.initialLoad();
        this._selectedGateway = v; 
    } public get selectedGateway(): IGateway { return this._selectedGateway;} private _selectedGateway: IGateway;
    
    async create(){
        let validationResult = this.validateInformation();
        if (validationResult.length != 0){
            await this.messageBoxConfirmWarning(validationResult.join('\r\n'),"خطا")
        }
        else{
            try {
                this.isLoading = true;
                let result = await this.selectedGateway.save(this);
                if(result.IsSuccessful){
                    await this.messageBoxConfirmSuccess(`سند دریافت و پرداخت به شماره ${result.TransactionCode} و اسناد حسابداری با شماره ${result.AccountingCode1} و ${result.AccountingCode2} ثبت شد.`,'ثبت دریافت');
                }
                this.close();
            } catch (ex) {
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    validateInformation(): string[] {
        let result: string[] = []
        if (this.personSelector.selectedItem == null) result.push('پرداخت کننده انتخاب نشده است.');
        if (this.personSelector.selectedItem != null && stringIsNullOrEmpty(this.selectedPersonName)) result.push('نام پرداخت کننده به درستی مشخص نشده است.');
        if (this.amount == null) result.push('مبلغ وارد نشده است.');
        if (this.time == null) result.push('تاریخ و زمان پرداخت مشخص نشده است.');
        if (this.selectedGateway == null) result.push('روش دریافت مشخص نشده است.');
        if (this.selectedGateway != null) result.push(...this.selectedGateway.validate());
        if (this.selectedReason == null) result.push('نوع پرداخت مشخص نشده است.');
        return result;
    }

    getBasePaymentInfoDto(): { Amount: number; RequestType: number; Time:moment.Moment; PersonId: string; Title: string; Comment: string; Attachments:{Id:string,Name:string,Data:string}[] } {
        return {
            Amount : this.amount,
            RequestType:this.selectedReason.id,
            Time : this.time,
            Title : this.comment,
            Comment : this.comment,
            PersonId : this.personSelector.selectedItem.id,
            Attachments : this.attachments.getAttachments().map(q=>{
                return {
                    Id :q.id,
                    Name:q.name,
                    Data:q.content
                };
            })
        };
    }
    
}

export class reason extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel,id:number) {
        super(parent);
        this.id = id;
        this.name = new TranslatorConverter().paymentProcessTypeNameConverter(id);
    }
    public set id(v: number) { this._id = v; } public get id(): number { return this._id;} private _id: number;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
}
